import React from 'react';
import { pointExcelRewardUpload } from '@/api/point/create';
import { CreateExcelRewardUploadRowType } from '@/types';
import ExcelUploadBase from './ExcelUploadBase';

export default function ExcelPointRewardUpload() {
  return (
    <ExcelUploadBase<CreateExcelRewardUploadRowType>
      dataType="포인트 리워드"
      onUpload={pointExcelRewardUpload}
      otpTitle="포인트 리워드 업로드 인증"
      otpDescription="포인트 리워드 업로드를 위해 OTP 인증이 필요합니다."
    />
  );
}
